import React, { useState, useCallback, useEffect } from "react";

import { useDeviceTesterStateContext } from "../../device-tester-context-provider/DeviceTesterContextProvider";

import { logDesktopPermissionsModalState } from "./DesktopPermissionPrompt.telemetry";
import { DesktopPermissionPrompt } from "./DesktopPermissionPrompt";

export const ConnectedDesktopPermissionPrompt: React.FC = () => {
  const { deviceTesterState } = useDeviceTesterStateContext();
  const [isCamOrMicAccessDenied, setCamOrMicAccessDenied] = useState<
    boolean | undefined
  >();

  const logStateChange = useCallback(
    (newState: boolean | undefined) => {
      // log only when the dialog state changes from open to/from close
      if (newState && newState !== isCamOrMicAccessDenied) {
        logDesktopPermissionsModalState(newState);
      }
    },
    [isCamOrMicAccessDenied]
  );

  useEffect(() => {
    if (deviceTesterState.isInfoFetched) {
      const newDialogState =
        !deviceTesterState.deviceSettings.cameraAccess ||
        !deviceTesterState.deviceSettings.micAccess;
      logStateChange(newDialogState);
      setCamOrMicAccessDenied(newDialogState);
    }
  }, [
    deviceTesterState.deviceSettings.cameraAccess,
    deviceTesterState.deviceSettings.micAccess,
    deviceTesterState.isInfoFetched,
    logStateChange,
  ]);

  if (deviceTesterState.isInfoFetched && isCamOrMicAccessDenied !== undefined) {
    return (
      <DesktopPermissionPrompt
        isCamOrMicAccessDenied={isCamOrMicAccessDenied}
      />
    );
  } else {
    return null;
  }
};
